import { render, staticRenderFns } from "./OverwriteDialog.vue?vue&type=template&id=b58d4cec&"
import script from "./OverwriteDialog.vue?vue&type=script&lang=js&"
export * from "./OverwriteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports